import {
  type Control,
  type FieldErrors,
  type UseFormRegister,
} from 'react-hook-form';
import { Stack, TextField } from '@mui/material';

import Section from '@pages/common/Project/Forms/Components/Section';
import { type ProjectSchema } from '@/zod_schemas';

interface ProjectFormProps {
  register: UseFormRegister<ProjectSchema>;
  errors: FieldErrors<ProjectSchema>;
  control: Control<ProjectSchema>; // Use union type here
}

const ProjectForm = ({ register, errors }: ProjectFormProps) => (
  <Section
    title="Project details"
    description="Use a concise name that helps the clinical team identify this workstream."
  >
    <Stack spacing={2.5} direction={{ xs: 'column', md: 'row' }}>
      <TextField
        id="project-name"
        label="Project name"
        aria-describedby="project name field"
        error={Boolean(errors.name)}
        helperText={errors.name?.message}
        fullWidth
        {...register('name')}
      />
      <TextField
        id="project-description"
        label="Description"
        aria-describedby="project description field"
        error={Boolean(errors.description)}
        helperText={errors.description?.message}
        fullWidth
        {...register('description')}
      />
    </Stack>
  </Section>
);

export default ProjectForm;
